import { useMemo } from "react";
import { getAccountData } from "../ts/commonTools";
import {
  normalizeAppManifest,
  normalizePageConfig,
} from "../appConfig/appConfig";
import {
  getAppClientVersion,
  getAppConfigOrigin,
  requestAppManifest,
  requestAppPage,
} from "../fetch/appConfig";
import useCustomQuery from "./useCustomQuery";

function getAppConfigDevice() {
  try {
    return window.matchMedia("(min-width: 700px)").matches ? "tablet" : "mobile";
  } catch {
    return "mobile";
  }
}

export function useAppManifest() {
  const origin = getAppConfigOrigin();
  const officeId = getAccountData.office_id();
  const clientVersion = getAppClientVersion();
  const device = getAppConfigDevice();
  const configured = Boolean(origin);
  const query = useCustomQuery({
    queryKey: ["appManifest", origin, officeId, device, clientVersion],
    queryFn: ({ signal }) => requestAppManifest({
      origin,
      officeId,
      clientVersion,
      device,
      signal,
    }),
    enabled: configured,
    retry: false,
  });
  const manifest = useMemo(
    () => normalizeAppManifest(query.data?.payload),
    [query.data?.payload],
  );

  return {
    manifest,
    configured,
    isLoading: configured && query.isLoading,
    error: query.error || null,
    refetch: query.refetch,
  };
}

export function useAppPageConfig(pageKey) {
  const origin = getAppConfigOrigin();
  const officeId = getAccountData.office_id();
  const clientVersion = getAppClientVersion();
  const device = getAppConfigDevice();
  const configured = Boolean(origin);
  const query = useCustomQuery({
    queryKey: ["appPageConfig", origin, officeId, pageKey, device, clientVersion],
    queryFn: ({ signal }) => requestAppPage({
      origin,
      officeId,
      pageKey,
      clientVersion,
      device,
      signal,
    }),
    enabled: configured && Boolean(pageKey),
    retry: false,
  });
  const pageConfig = useMemo(
    () => normalizePageConfig(pageKey, query.data?.payload),
    [pageKey, query.data?.payload],
  );

  return {
    pageConfig,
    configured,
    isLoading: configured && query.isLoading,
    error: query.error || null,
    refetch: query.refetch,
  };
}
